import * as React from 'react';
import { AddonContext, CellContext } from '../generics';
import CellBase from './cell-base';
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
export var ProductTableCellPlaceholder = function ProductTableCellPlaceholder() {
  var _React$useContext = React.useContext(CellContext),
      inSplit = _React$useContext.inSplit;

  var _React$useContext2 = React.useContext(AddonContext),
      inAddon = _React$useContext2.inAddon;

  return _jsxs(CellBase, {
    sx: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: inAddon ? 'rgba(91, 38, 255, 0.2)' : 'rgba(255, 51, 38, 0.2)',
      minHeight: inSplit || inAddon ? 0 : 150
    },
    mobileOrder: inAddon ? 0 : 2,
    children: ["Placeholder ", inSplit ? 'column' : inAddon ? 'addon' : 'row']
  });
};
export default ProductTableCellPlaceholder;
//# sourceMappingURL=cell-placeholder.js.map